module.exports = __webpack_public_path__ + "img/publications11_gecell.d44fc10d.jpg";